export class TabStatus {
  tabName!: string;
  tabValid!: boolean;
}
